var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAgentTypeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4172 11.3871V12.5029H8.75V11.3871C5.6513 11.2537 2.9794 10.3956 1.25 9.10193V16.5C1.25 17.0523 1.69772 17.5 2.25 17.5H16.9216C17.4739 17.5 17.9216 17.0523 17.9216 16.5V9.10637C16.1878 10.3956 13.5159 11.2537 10.4172 11.3871Z",
    fill: "#34657F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.59025 9.74214C13.7693 9.74214 16.8502 8.3684 17.9216 6.79016C17.9216 6.26226 17.4937 5.83432 16.9658 5.83432H12.9201V3.5C12.9201 2.94772 12.4724 2.5 11.9201 2.5H7.25148C6.6992 2.5 6.25148 2.94772 6.25148 3.5V5.83432H2.19695C1.67396 5.83432 1.25 6.25828 1.25 6.78127C2.31698 8.35951 5.40234 9.74214 9.59025 9.74214ZM7.91864 4.16716H11.253V5.83432H7.91864V4.16716Z",
    fill: "#34657F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgentTypeIcon);
export default __webpack_public_path__ + "static/media/agent-type-icon.7c1ccd19d15b21cf8c2b798895da24b9.svg";
export { ForwardRef as ReactComponent };